export default function getScrollOpacity(startingOpacity) {
    const scrollY = window.scrollY;
    return Math.min(startingOpacity + scrollY / 800, 1);
}
